export const checkFeeInfo = (
  prefix: string,
  value: string,
  dangle = ''
): string => {
  return value && !value.includes('0') ? `${prefix} ${value}${dangle}` : '';
};
